import type { Moment } from 'moment';

import moment from './moment';

const momentPrefix = '#moment#';

export const serializeDeprecated = (element: any): any => {
  if (!element) {
    return element;
  }
  if (Array.isArray(element)) {
    return element.map((value) => serializeDeprecated(value));
  }
  if (element instanceof moment) {
    return `${momentPrefix}${(element as Moment).toISOString()}`;
  }
  if (typeof element === 'object') {
    const newElement: any = {};
    Object.keys(element).forEach((key) => {
      newElement[key] = serializeDeprecated(element[key]);
    });
    return newElement;
  }
  return element;
};

export const deserializeDeprecated = (element: any): any => {
  if (!element) {
    return element;
  }
  if (Array.isArray(element)) {
    return element.map((value) => deserializeDeprecated(value));
  }
  if (typeof element === 'string' && element.startsWith(momentPrefix)) {
    return moment(element.substring(momentPrefix.length));
  }
  if (typeof element === 'object') {
    const newElement: any = {};
    Object.keys(element).forEach((key) => {
      newElement[key] = deserializeDeprecated(element[key]);
    });
    return newElement;
  }
  return element;
};
